/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Disconnected_DescInputs */



/**
* | output |
* | --- |
* | "The {provider} integration was disconnected from the organisation." |
*
* @param {Audit_Details_Integration_Disconnected_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_disconnected_desc = /** @type {((inputs: Audit_Details_Integration_Disconnected_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Disconnected_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Integration ${i?.provider} wurde von der Organisation getrennt.`)
	return /** @type {LocalizedString} */ (`The ${i?.provider} integration was disconnected from the organisation.`)
});